import type { BaseDictionaryItem } from './dictionaryUtils'

export interface ExternalSystemItem extends BaseDictionaryItem {
  agreementUrlPath: string | null
}

export const EXTERNAL_SYSTEMS: readonly ExternalSystemItem[] = [
  { key: 'k2k', label: 'Key2Key', agreementUrlPath: '/customer/{{financePlanId}}' },
  { key: 'emaster', label: 'eMaster', agreementUrlPath: null },
  { key: 'p360', label: 'P360', agreementUrlPath: null },
  { key: 'dealerweb', label: 'DealerWeb', agreementUrlPath: null },
  { key: 'trackback', label: 'Trackback', agreementUrlPath: null },
  { key: 'enquirymax', label: 'EnquiryMax', agreementUrlPath: null },
  { key: 'salesforce', label: 'Salesforce', agreementUrlPath: null },
  { key: 'blackhorse', label: 'Blackhorse', agreementUrlPath: null },
  { key: 'keyloop-leads', label: 'Keyloop Leads', agreementUrlPath: null },
  { key: 'ERROR', label: 'ERROR', agreementUrlPath: null }
] as const
